import { Icon } from 'ant-design-vue';

export const IconFont = Icon.createFromIconfontCN({
    // scriptUrl: '//at.alicdn.com/t/font_8d5l8fzk5b87iudi.js',
})